import React, {useRef} from "react";
import {bookingType, colorBookingPaid, GLOBAL_BORDER_RADIUS} from "../../../costants";
import MainButton from "../../commons/mainButton";
import {Calendar, momentLocalizer, Views} from "react-big-calendar";
import moment from "moment/moment";
import AsyncStorage from "@react-native-async-storage/async-storage";
import CustomToolbar from "./myPremiumCalendarToolbar";
import useMyEscapeListener from "../../../global/listeners/useMyEscapeListener";
import MyNormalText from "../../commons/myNormalText";
import MyIcon from "../../commons/myIcon";
import AvailabilityPopup from "./availabilityPopup";

moment.locale('it', {week: {dow: 1}})
export const localizer = momentLocalizer(moment)
export const formatsCalendar = {
    timeGutterFormat: 'H:mm',
    eventTimeRangeFormat: ({start, end}, culture, localizer) =>
        `${localizer.format(start, 'H:mm', culture)} - ${localizer.format(end, 'H:mm', culture)}`
}

const INCREASE_CALENDAR_HEIGHT_VALUE = 80

function MyPremiumCalendar({
                               rentUser,
                               accountType,
                               zoomCalendar,
                               premiumPalette,
                               setZoomCalendar,
                               calendarEvents,
                               selectedDay,
                               handleSelectEvent,
                               handleNavigate,
                               handleOpenBookingCreator,
                               refreshMyPremiumCalendarComponent,
                               calendarHeight,
                               setCalendarHeight
                           }) {

    const isPaymentLinksOnly = Boolean(accountType?.isAccountPremiumPaymentLinksOnly)

    const fontColor = premiumPalette.isDarkMode ? 'white' : undefined
    const primaryColorFirstAlternative = premiumPalette.primaryColorFirstAlternative
    const buttonHeight = 35

    const timerRef = useRef(null)

    useMyEscapeListener(() => setZoomCalendar(false))

    const eventPropGetter = (event, start, end, isSelected) => {
        return {
            style: {backgroundColor: event.backgroundColor, borderRadius: 15}
        }
    }

    function changeCalendarHeight(increase) {
        if (!increase && calendarHeight <= 500) {
            return
        }

        const increment = increase ? INCREASE_CALENDAR_HEIGHT_VALUE : -INCREASE_CALENDAR_HEIGHT_VALUE
        setCalendarHeight(calendarHeight + increment)
        AsyncStorage.setItem('premium-calendar-height', JSON.stringify(calendarHeight))
            .then(() => {
                if (timerRef.current) {
                    clearTimeout(timerRef.current)
                }

                timerRef.current = setTimeout(() => {
                    refreshMyPremiumCalendarComponent()
                }, 200)
            })
    }

    function getDecreaseCalendarHeight() {
        return (
            <div style={{display: 'flex', justifyContent: 'center'}}>
                <div style={{width: 10, height: 2, backgroundColor: premiumPalette.isDarkMode ? 'white' : 'black'}}/>
            </div>
        )
    }

    function getButtons() {
        return (
            <div style={pageStyle.mainContainerButtons}>
                <div>
                    <MainButton text={'Inserisci ordine'}
                                action={() => handleOpenBookingCreator()}
                                height={buttonHeight}
                                backgroundColor={premiumPalette.primaryColor}/>
                </div>
                <div>
                    <AvailabilityPopup rentUser={rentUser}
                                       buttonHeight={buttonHeight}
                                       disabled={isPaymentLinksOnly}
                                       premiumPalette={premiumPalette}/>
                </div>
                <div style={{display: 'flex', alignItems: 'center', gap: 20}}>
                    <div style={pageStyle.containerButtonsHeight}>
                        <MainButton injectMainBody={getDecreaseCalendarHeight()}
                                    action={() => changeCalendarHeight(false)}
                                    textBold={true}
                                    disabled={isPaymentLinksOnly}
                                    height={buttonHeight}
                                    paddingHorizontal={20}
                                    backgroundColor={premiumPalette.primaryColor}/>
                        <MainButton text={'+'}
                                    action={() => changeCalendarHeight(true)}
                                    textBold={true}
                                    disabled={isPaymentLinksOnly}
                                    height={buttonHeight}
                                    paddingHorizontal={20}
                                    backgroundColor={premiumPalette.primaryColor}/>
                    </div>
                    <div>
                        <MainButton
                            image={zoomCalendar ? require("../../../imgs/actions/dezoom.png") : require("../../../imgs/actions/zoom.png")}
                            action={() => setZoomCalendar(!zoomCalendar)}
                            disabled={isPaymentLinksOnly}
                            height={buttonHeight}
                            backgroundColor={premiumPalette.primaryColor}/>
                    </div>
                </div>
            </div>
        )
    }

    function calculateItemsStatus(event) {
        if (!event.itemsPickedUp && !event.itemsReturned) {
            return (
                <div title={'Il cliente deve passare a ritirare gli articoli'}>
                    <MyIcon icon={require('../../../imgs/actions/items-pending.png')}
                            name={'items-pending'}
                            width={20}
                            height={20}/>
                </div>)
        } else if (event.itemsPickedUp && !event.itemsReturned) {
            return (
                <div title={'Articoli ritirati dal cliente'}>
                    <MyIcon icon={require('../../../imgs/actions/items-picked-up.png')}
                            name={'items-picked'}
                            width={22}
                            height={22}/>
                </div>)
        } else if (event.itemsPickedUp && event.itemsReturned) {
            return (
                <div title={'Articoli riconsegnati dal cliente'}>
                    <MyIcon icon={require('../../../imgs/actions/done.png')}
                            name={'items-picked'}
                            width={20}
                            height={20}/>
                </div>)
        }
    }

    const EventComponent = ({event}) => {
        return (
            <div style={{...pageStyle.dotIsPaidContainer, backgroundColor: event.backgroundColor}}
                 title={event.itemNames}>
                <MyNormalText text={event.title}
                              textOverflow={true}
                              color={'white'}/>
                <div style={{display: 'flex', alignItems: 'center', gap: 3}}>
                    {event.type === bookingType.SYSTEM_AUTOMATIC ?
                        <div style={{padding: 2, borderRadius: 50, backgroundColor: 'white'}}>
                            <MyIcon icon={require('../../../imgs/booking/logo.png')}
                                    name={'logo-app'}
                                    neverInvert={true}
                                    width={18}
                                    height={18}/>
                        </div> :
                        <></>}
                    <div style={{
                        ...pageStyle.dotIsPaid,
                        backgroundColor: event.isPaid ? colorBookingPaid.YES : colorBookingPaid.NO
                    }}/>
                    {calculateItemsStatus(event)}
                </div>
            </div>
        )
    }

    function getCalendar(style) {
        return <Calendar localizer={localizer}
                         formats={formatsCalendar}
                         eventPropGetter={eventPropGetter}
                         components={{
                             toolbar: (props) => <CustomToolbar {...props}
                                                                premiumPalette={premiumPalette}
                                                                buttonHeight={buttonHeight}/>,
                             event: EventComponent
                         }}
                         events={calendarEvents}
                         date={selectedDay}
                         defaultView={Views.MONTH}
                         views={[Views.MONTH, Views.DAY]}
                         style={style}
                         onSelectEvent={handleSelectEvent}
                         onNavigate={handleNavigate}/>
    }

    function renderCalendarContainer(calendarStyleToUse) {
        return (
            <div style={pageStyle.calendarWrapper}>
                <div style={{
                    filter: isPaymentLinksOnly ? 'blur(6px)' : 'none',
                    pointerEvents: isPaymentLinksOnly ? 'none' : 'auto',
                    userSelect: isPaymentLinksOnly ? 'none' : 'auto',
                    opacity: isPaymentLinksOnly ? 0.6 : 1
                }}>
                    {getCalendar(calendarStyleToUse)}
                </div>
                {isPaymentLinksOnly && (
                    <div style={pageStyle.blurOverlayContainer}>
                        <div style={{
                            ...pageStyle.blurOverlayCard,
                            backgroundColor: primaryColorFirstAlternative,
                            color: fontColor
                        }}>
                            <MyIcon icon={require('../../../imgs/actions/info.png')}
                                    name={'info'}
                                    width={32}
                                    height={32}/>
                            <MyNormalText text={'Visualizzazione calendario non disponibile'}
                                          bold={true}
                                          fontSize={16}/>
                            <MyNormalText text={'Il tuo piano è abilitato all\'inserimento delle prenotazioni e all\'invio dei link di pagamento, ma non alla consultazione del calendario.'}
                                          fontSize={13}/>
                        </div>
                    </div>
                )}
            </div>
        )
    }

    if (zoomCalendar) {
        return (
            <div style={{
                ...pageStyle.innerContainerFullPage,
                backgroundColor: primaryColorFirstAlternative,
                color: fontColor
            }}>
                {getButtons()}
                {renderCalendarContainer({...pageStyle.calendarStyleFullPage, height: calendarHeight})}
            </div>
        )
    }

    return (
        <div style={{color: fontColor}}>
            {getButtons()}
            {renderCalendarContainer({...pageStyle.calendarStyle, height: calendarHeight})}
        </div>
    )
}

const pageStyle = {
    innerContainerFullPage: {
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        overflowY: 'scroll',
        scrollbarWidth: 'none',
        padding: 20,
        zIndex: 1
    },
    mainContainerButtons: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 10
    },
    containerButtonsHeight: {
        display: 'flex',
        alignItems: 'center',
        gap: 5
    },
    calendarWrapper: {
        position: 'relative',
        width: '100%'
    },
    calendarStyle: {
        borderRadius: GLOBAL_BORDER_RADIUS
    },
    calendarStyleFullPage: {
        width: '100%',
        borderRadius: GLOBAL_BORDER_RADIUS
    },
    dotIsPaidContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    dotIsPaid: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 20,
        height: 20,
        borderRadius: '50%',
        border: '1px solid white'
    },
    blurOverlayContainer: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 5,
        padding: 20
    },
    blurOverlayCard: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        gap: 10,
        padding: '20px 30px',
        borderRadius: GLOBAL_BORDER_RADIUS,
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.25)',
        maxWidth: 420
    }
}

export default MyPremiumCalendar
